module.exports = __webpack_public_path__ + "img/documental--icon.6808f204.svg";